import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { SITE, IMAGES } from '../mock';

export default function Footer() {
  return (
    <footer className="relative mt-32 border-t border-white/5 bg-[#08080a]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <Link to="/" className="inline-flex items-center gap-3">
            <img src={IMAGES.logo} alt="Moonshine" className="h-20 w-auto drop-shadow-[0_0_24px_rgba(212,181,116,0.2)]" />
          </Link>
          <p className="mt-5 text-sm leading-relaxed text-[#9a9285] max-w-sm">
            Geschäftsführer der <span className="text-[#e8d5a8]">Moonshine Solutions GmbH</span>. Dein persönlicher Experte für inflationsgeschützten und steueroptimierten Vermögensaufbau.
          </p>
          <div className="flex items-center gap-3 mt-6">
            {[
              { icon: Facebook, href: SITE.social.facebook },
              { icon: Instagram, href: SITE.social.instagram },
              { icon: Linkedin, href: SITE.social.linkedin },
              { icon: Mail, href: SITE.social.mail },
            ].map((s, i) => (
              <a
                key={i}
                href={s.href}
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-[#cfc6b5] hover:border-[#d4b574]/50 hover:text-[#e8d5a8] hover:bg-[#d4b574]/5 transition-all"
              >
                <s.icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="text-xs uppercase tracking-[0.22em] text-[#7a7060] mb-4">Navigation</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Home</Link></li>
            <li><Link to="/ueber-uns" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Über uns</Link></li>
            <li><Link to="/angebot" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Angebot</Link></li>
            <li><Link to="/kontakt" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Kontakt</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#7a7060] mb-4">Leistungen</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/immobilien" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Immobilien</Link></li>
            <li><Link to="/alphalane" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Alphalane AI</Link></li>
            <li><Link to="/vorsorge" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Vorsorgegelder finden</Link></li>
            <li><Link to="/edelmetalle" className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">Edelmetalle</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <div className="text-xs uppercase tracking-[0.22em] text-[#7a7060] mb-4">Kontakt</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href={`mailto:${SITE.email}`} className="text-[#cfc6b5] hover:text-[#e8d5a8] transition-colors">{SITE.email}</a></li>
            <li className="text-[#9a9285]">Schweiz</li>
          </ul>
          <a
            href={SITE.vorsorgecheckUrl}
            target="_blank"
            rel="noreferrer"
            className="inline-block mt-6 px-5 py-2.5 text-sm rounded-full bg-[#d4b574] text-[#0a0a0c] font-medium hover:bg-[#e8d5a8] transition-colors"
          >
            Finanzcheck starten
          </a>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <div className="text-xs text-[#7a7060]">
            © {new Date().getFullYear()} {SITE.brandFull}. Alle Rechte vorbehalten.
          </div>
          <div className="flex items-center gap-5 text-xs text-[#9a9285]">
            <Link to="/impressum" className="hover:text-[#e8d5a8] transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-[#e8d5a8] transition-colors">Datenschutz</Link>
            <Link to="/agb" className="hover:text-[#e8d5a8] transition-colors">AGB</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
